import { Controller } from "@hotwired/stimulus"

// Widens the click target of a table row to the whole row, for a list whose row has a
// single destination. The row keeps a real anchor (the link target), so keyboard
// navigation, middle-click, and copy-link-address go on working as they always did —
// this only forwards clicks that land on the row's dead space to that anchor.
export default class extends Controller {
  static targets = ["link"]

  visit(event) {
    if (!this.hasLinkTarget) return

    // A click on something that already does something of its own — a nested link, a
    // button, a form field — belongs to that control, not to the row.
    if (event.target.closest("a, button, input, label, select, textarea, [role='button']")) return

    // Don't navigate away from text the user was in the middle of selecting.
    const selection = window.getSelection()
    if (selection && !selection.isCollapsed) return

    // The modifiers a browser reads as "not here" on a real link. Middle-click needs no
    // branch — it never reaches a click handler, and the anchor already handles it.
    if (event.ctrlKey || event.metaKey || event.shiftKey) {
      window.open(this.linkTarget.href, "_blank")
    } else {
      this.linkTarget.click()
    }
  }
}
